const NAMESPACE = "dismissibleBanner";

const KEYS = {
    dismissButtonText: "dismissButtonText",
    hideButtonText: "hideButtonText",
    dontShowAgainButtonText: "dontShowAgainButtonText"
};

const MESSAGES = {
    [KEYS.dismissButtonText]: {
        value: "Dismiss",
        comment: "Text for a dropdown toggle that exposes other dismiss options"
    },
    [KEYS.hideButtonText]: {
        value: "Hide",
        comment: "Text for a button that hides a banner temporarily"
    },
    [KEYS.dontShowAgainButtonText]: {
        value: "Don't show again",
        comment: "Text for a button that hides a banner indefinitely"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
